/*
 * Copyright (c) 2025. Sergey S. Chernov - All Rights Reserved
 *
 *  You may use, distribute and modify this code under the
 * terms of the private license, which you must obtain from the author
 *
 * To obtain the license, contact the author: https://t.me/real_sergeych or email to
 * real dot sergeych at gmail.
 */

package net.sergeych.crypto2

import com.ionspin.kotlin.crypto.util.decodeFromUByteArray
import net.sergeych.bipack.BipackDecoder
import net.sergeych.bipack.decodeFromBipack
import net.sergeych.crypto2.SymmetricKey.WithNonce

/**
 * Some key able to perform decrypting. It is not serializable by purpose, as not all such
 * keys are wise to transfer/save. Concrete implementations are, like [SymmetricKey] or
 * [DecryptingSecretKey].
 */
interface DecryptingKey : NonceBased, KeyInstance {
    /**
     * Authenticated decryption that checks the message is not tampered and therefor
     * the key is valid. It is not possible in general to distinguish whether the key is invalid
     * or the encrypted data is tampered so the only one exception is used.
     *
     * @throws DecryptionFailedException if the key is not valid or [cipherData] tampered.
     */
    fun decrypt(cipherData: UByteArray): UByteArray =
        protectDecryption {
            val wn: WithNonce = cipherData.asByteArray().decodeFromBipack()
            decryptWithNonce(wn.cipherData, wn.nonce)
        }

    fun decryptWithNonce(cipherData: UByteArray, nonce: UByteArray): UByteArray


    fun decryptString(cipherData: UByteArray): String = decrypt(cipherData).decodeFromUByteArray()

}

inline fun <reified T>DecryptingKey.decryptObject(cipherData: UByteArray): T =
    BipackDecoder.decode<T>(decrypt(cipherData).asByteArray())